module.exports = __webpack_public_path__ + "static/media/living_kitchen_green.a4ad089d.jpg";